const Permission = {
    ALL: "ALL",

    DASHBOARD_USER_GRAPH: "DASHBOARD_USER_GRAPH",
    DASHBOARD_CUSTOMER_COUNT: "DASHBOARD_CUSTOMER_COUNT",

    ADMIN_DASHBOARD: "ADMIN_DASHBOARD",
    OWNER_DASHBOARD: "OWNER_DASHBOARD",

    READ_ROLE: "READ_ROLE",
    MODIFY_ROLE: "MODIFY_ROLE",
    DELETE_ROLE: "DELETE_ROLE",

    CREATE_ROLE: "CREATE_ROLE",
    CREATE_USER: "CREATE_USER",
    MODIFY_USER: "MODIFY_USER",
    DELETE_USER: "DELETE_USER",
    READ_USER: "READ_USER",
    UPDATE_USER_PASSWORD: "UPDATE_USER_PASSWORD",

    MODIFY_USER_PROFILE: "MODIFY_USER_PROFILE",
    UPDATE_PROFILE_PASSWORD: "UPDATE_PROFILE_PASSWORD",
    READ_USER_PROFILE: "READ_USER_PROFILE",

    CREATE_ADDRESS: "CREATE_ADDRESS",
    DELETE_ADDRESS: "DELETE_ADDRESS",
    MODIFY_ADDRESS: "MODIFY_ADDRESS",
    READ_ADDRESS: "READ_ADDRESS",

    CREATE_PERSONAL_ADDRESS: "CREATE_PERSONAL_ADDRESS",
    DELETE_PERSONAL_ADDRESS: "DELETE_PERSONAL_ADDRESS",
    READ_PERSONAL_ADDRESS: "READ_PERSONAL_ADDRESS",
    MODIFY_PERSONAL_ADDRESS: "MODIFY_PERSONAL_ADDRESS",

    READ_RESTAURANT_OWNER: "READ_RESTAURANT_OWNER",
    READ_RESTAURANT_OWNER_PROFILE: "READ_RESTAURANT_OWNER_PROFILE",
    CREATE_RESTAURANT_OWNER: "CREATE_RESTAURANT_OWNER",
    MODIFY_RESTAURANT_OWNER: "MODIFY_RESTAURANT_OWNER",

    READ_SCHEDULE: "READ_SCHEDULE",
    CREATE_SCHEDULE: "CREATE_SCHEDULE",
    MODIFY_SCHEDULE: "MODIFY_SCHEDULE",
    DELETE_SCHEDULE: "DELETE_SCHEDULE",

    READ_FLOOR: "READ_FLOOR",
    CREATE_FLOOR: "CREATE_FLOOR",
    MODIFY_FLOOR: "MODIFY_FLOOR",
    DELETE_FLOOR: "DELETE_FLOOR",

    READ_TABLE_LAYOUT: "READ_TABLE_LAYOUT",
    CREATE_TABLE_LAYOUT: "CREATE_TABLE_LAYOUT",
    MODIFY_TABLE_LAYOUT: "MODIFY_TABLE_LAYOUT",
    DELETE_TABLE_LAYOUT: "DELETE_TABLE_LAYOUT",
    TABLE_LAYOUT_IMAGE_UPLOAD: "TABLE_LAYOUT_IMAGE_UPLOAD",

    READ_RESTAURANT_CONFIG: "READ_RESTAURANT_CONFIG",
    CREATE_RESTAURANT_CONFIG: "CREATE_RESTAURANT_CONFIG",
    MODIFY_RESTAURANT_CONFIG: "MODIFY_RESTAURANT_CONFIG",
    DELETE_RESTAURANT_CONFIG: "DELETE_RESTAURANT_CONFIG",

    READ_RESTAURANT_TOKEN: "READ_RESTAURANT_TOKEN",
    CREATE_RESTAURANT_TOKEN: "CREATE_RESTAURANT_TOKEN",
    MODIFY_RESTAURANT_TOKEN: "MODIFY_RESTAURANT_TOKEN",
    DELETE_RESTAURANT_TOKEN: "DELETE_RESTAURANT_TOKEN",

    READ_BOOKING: "READ_BOOKING",
    CREATE_BOOKING: "CREATE_BOOKING",
    MODIFY_BOOKING: "MODIFY_BOOKING",
    DELETE_BOOKING: "DELETE_BOOKING",

    READ_PERSONAL_RESTAURANT: "READ_PERSONAL_RESTAURANT",
    READ_RESTAURANT: "READ_RESTAURANT",
    CREATE_RESTAURANT: "CREATE_RESTAURANT",
    MODIFY_RESTAURANT: "MODIFY_RESTAURANT",
    DELETE_RESTAURANT: "DELETE_RESTAURANT",

    IMAGE_UPLOAD: "IMAGE_UPLOAD",

    READ_PERMISSION: "READ_PERMISSION",
}

export default Permission;
